/**
 * BOTTOM GENERAL INITS
 * "MEDIA"
 */

import { MediaImage } from "./mediaImage";
import { LiveVideo } from "./live-video";
import { MediaVideoGrouper } from "./mediaVideoGrouper";
import { MediaImagePlaylist } from "./mediaImagePlaylist";


export class MediaInits {
    constructor() {
        this.initMap();
    }

    initMap() {
        new MediaImage();
        new LiveVideo();
        new MediaVideoGrouper();
        new MediaImagePlaylist();
    }
}
